module.exports = "https://web-assets-production.autolist.com/_next/static/images/crossover-angled-8bf8b5c4fa54b2e9b2ede52af74b3707.jpg";